export const mockActivityPanel = [
  {
    name: 'panel.activity.messages.MainTitle',
    path: 'panel.activity.url.messages',
    type: 'messages',
    dataPanel: 'actividad_messages_title',
    external: false
  },
  {
    name: 'panel.activity.favorites.MainTitle',
    path: 'panel.activity.url.favorites',
    type: 'favorites',
    dataPanel: 'actividad_favorites_title',
    external: false
  },
  {
    name: 'panel.activity.viewed.MainTitle',
    path: 'panel.activity.url.viewed',
    type: 'viewed',
    dataPanel: 'actividad_viewed_title',
    external: false
  },
  {
    name: 'panel.activity.discarded.MainTitle',
    path: 'panel.activity.url.discarded',
    type: 'discarded',
    dataPanel: 'actividad_discarded_title',
    external: false
  },
  {
    name: 'panel.activity.savedSearches.MainTitle',
    path: 'panel.activity.url.savedSearches',
    type: 'alerts',
    dataPanel: 'actividad_alerts_title',
    external: false
  }
];
